import { useContext } from 'react';
import { LocationContext } from '../contexts/LocationContext';

export function useLocations() {
  const ctx = useContext(LocationContext);
  if (!ctx) throw new Error('useLocations must be used within LocationProvider');
  return ctx;
}
